import { motion } from "framer-motion";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, RevealLineOnScroll } from "./Reveal";
import { CONSUMER_STEPS, EASE } from "../data";

export const Consumers = () => {
  return (
    <section
      id="consumers"
      data-testid="consumers-section"
      className="bg-white text-black pt-16 md:pt-20 pb-10 md:pb-12 border-t"
      style={{ borderColor: "var(--border-light)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[color:var(--primary-accent)] mb-6">
              For Consumers
            </p>
          </Reveal>
          {/* <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.03]">
            <RevealLineOnScroll>Get Straight Card</RevealLineOnScroll>
            <RevealLineOnScroll delay={0.07}>in seconds.</RevealLineOnScroll>
          </h2> */}
          <Reveal delay={0.2}>
            <p className="mt-8 text-lg text-black/60 max-w-md leading-relaxed">
              Connect it to your wallet and you&apos;re all set to spend at any
              on-chain point of sale.
            </p>
            <a
              href="#"
              data-testid="pos-locations-link"
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--primary-accent)] hover:gap-3 transition-all duration-300"
            >
              <MapPin size={16} />
              Check live locations of POS
              <ArrowUpRight size={16} />
            </a>
            <p className="mt-8 font-display text-2xl font-semibold">
              We&apos;ll handle the payments.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div
            className="rounded-2xl overflow-hidden border"
            style={{ borderColor: "var(--border-light)" }}
          >
            {CONSUMER_STEPS.map((step, i) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: EASE, delay: i * 0.08 }}
                className={`group bg-[#f5f5f7] p-6 md:p-8 flex items-start gap-6 ${
                  i > 0 ? "border-t" : ""
                }`}
                style={{ borderColor: "var(--border-light)" }}
                data-testid={`consumer-step-${i + 1}`}
              >
                <span
                  className="font-mono-str text-sm shrink-0 mt-1"
                  style={{ color: "var(--primary-accent)" }}
                >
                  0{i + 1}
                </span>
                <div className="flex-1">
                  <h3 className="font-display text-xl md:text-2xl font-semibold tracking-tight">
                    {step.title}
                  </h3>
                  <p className="mt-1.5 text-sm md:text-base text-black/55">
                    {step.desc}
                  </p>
                </div>
                <ArrowUpRight
                  size={18}
                  className="text-black/25 group-hover:text-[color:var(--primary-accent)] transition-colors duration-300 shrink-0 mt-1"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
